'use strict'

// Displays the terms of use link. Link text and url are localized
Vue.component('awe-swaven-link', {
  props: {
    wtbid: {type: String},
    visible: {type: Boolean, default: true}
  },
  computed: {
    url: function(){
      return `//www.swaven.com/?utm_source=awe&utm_medium=wtb&utm_campaign=${this.wtbid}`
    }
  },
  template: `
    <a v-if="visible" class="swaven-link" title="Swaven" alt="Swaven" :href="url"  target="_blank">
      <img src="https://content.static-swaven.com/img/logos/2021/s.png" width="22">
    </a>
  `
})
